// extracted by mini-css-extract-plugin
export var active = "_2e-d";
export var blink = "_2e-e";
export var container = "_2e-5";
export var controls = "_2e-0";
export var controlsRight = "_2e-1";
export var fakeCursor = "_2e-c";
export var hidden = "_2e-b";
export var quillContainerSmall = "_2e-7";
export var quillEditor = "_2e-6";
export var quillEditorSmall = "_2e-8";
export var quillFormatButtons = "_2e-a";
export var quillToolbar = "_2e-9";
export var removePadding = "_2e-2";
export var state = "_2e-3";
export var stateTitle = "_2e-4";